// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2Xxpc","empty":"ModalGraph_empty__29YDV"};